/* eslint-disable no-undef */

const fadeInLeft = (sections) => {
  Array.from(sections).forEach((section) => {
    const fadeInLeftTl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        end: "bottom 80%",
      },
    });

    gsap.set(section, {
      x: 600,
    });

    fadeInLeftTl.to(section, {
      x: 0,
    });
  });
};

const showVideo = (section) => {
  const showVideoTl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 80%",
      end: "70% 80%",
      scrub: 1,
    },
  });

  gsap.set(section, {
    opacity: 0,
  });

  showVideoTl.to(section, {
    opacity: 1,
  });
};

const fadeInItems = (items) => {
  Array.from(items).forEach((item) => {
    const fadeInTl = gsap.timeline({
      scrollTrigger: {
        trigger: item,
        start: "top 80%",
        end: "bottom 80%",
        scrub: 1,
      },
    });

    gsap.set(item, {
      opacity: 0,
      x: 280,
    });

    fadeInTl.to(item, {
      opacity: 1,
      x: 0,
    });
  });
};

export default (aboutUsAnimations = () => {
  const title = document.querySelectorAll(".information-section__heading h2");

  const titleClosingSection = document.querySelectorAll(
    ".closing-section__heading h2",
  );

  const videoSection = document.querySelector(".video-section__container");

  const recognitionsItems = document.querySelectorAll(
    ".closing-section__items ul li",
  );

  title && fadeInLeft(title);
  recognitionsItems && fadeInItems(recognitionsItems);
  videoSection && showVideo(videoSection);

  if (titleClosingSection) {
    if (window.matchMedia("(min-width: 850px)").matches) {
      fadeInLeft(titleClosingSection);
    }
  }
});
